module.exports = __webpack_public_path__ + "img/brackets_right_layout_icon.6aaa75b5.svg";